/* ============================================================
   Izzie's FAQ — category rail filter + text search + accordions.
   Vanilla custom element (no dependencies). Accessible:
   each question is a <button aria-expanded>, panels get aria-hidden.
   ============================================================ */
class IzzieFaq extends HTMLElement {
  connectedCallback() {
    this.cats = Array.from(this.querySelectorAll('.izzie-faqx__cat'));
    this.cards = Array.from(this.querySelectorAll('.izzie-faqcard'));
    this.input = this.querySelector('.izzie-faqx__input');
    this.empty = this.querySelector('.izzie-faqx__empty');
    this.activeCat = this.cats.length ? this.cats[0].dataset.faqCat : null;

    // Initialise collapsed panels for screen readers
    this.cards.forEach((card) => {
      const panel = card.querySelector('.izzie-faqcard__a');
      if (panel) panel.setAttribute('aria-hidden', 'true');
    });

    // Category rail
    this.cats.forEach((cat) => {
      cat.addEventListener('click', () => {
        this.activeCat = cat.dataset.faqCat;
        if (this.input) this.input.value = '';
        this.render();
      });
    });

    // Search
    if (this.input) {
      this.input.addEventListener('input', () => this.render());
    }

    // Accordion (event delegation)
    this.addEventListener('click', (event) => {
      const btn = event.target.closest('.izzie-faqcard__q');
      if (!btn || !this.contains(btn)) return;
      const card = btn.closest('.izzie-faqcard');
      const isOpen = card.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      const panel = card.querySelector('.izzie-faqcard__a');
      if (panel) panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    });

    this.render();
  }

  render() {
    const query = this.input ? this.input.value.trim().toLowerCase() : '';
    let visible = 0;

    this.cards.forEach((card) => {
      let show;
      if (query) {
        show = (card.dataset.faqText || '').indexOf(query) !== -1;
      } else {
        show = this.activeCat ? card.dataset.faqCat === this.activeCat : true;
      }
      card.hidden = !show;
      if (show) visible += 1;
    });

    // Rail active state (dimmed while searching)
    this.cats.forEach((cat) => {
      cat.classList.toggle('is-active', !query && cat.dataset.faqCat === this.activeCat);
    });

    if (this.empty) this.empty.hidden = visible > 0;
  }
}

if (!customElements.get('izzie-faq')) {
  customElements.define('izzie-faq', IzzieFaq);
}
